import React, { useEffect } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
function Sports() {
    useEffect(() => {
        document.title = 'Sports -  CARMEL CONVENT SCHOOL, DHARUHERA';
    }, []);
    return (
        <>
            <Header />
            <div className="sliderbg"></div>
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ul className="breadcrumbli">
                                <li><Link to="/"> Home </Link></li>
                                <li>Sports</li>
                            </ul>
                        </div>
                        <div className="col-lg-12">
                            <h2 className="innerheading">Sports</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p>At Carmel Convent School, we believe that sports play a vital role in the holistic development of every child. We provide excellent opportunities for students to develop physical fitness, discipline, leadership, teamwork, and a spirit of healthy competition through a wide range of indoor and outdoor sports activities.
                            </p>
                            <p>Our students actively participate in Taekwondo, Basketball, Football, and various other games including athletics, badminton, chess, carrom, table tennis, kho-kho, volleyball, and recreational sports. Under the guidance of qualified coaches and dedicated sports teachers, students receive regular training that helps them build confidence, resilience, and sportsmanship.
                            </p>
                            <p>Our Taekwondo team has brought immense pride to the school by participating in National-Level Taekwondo Championships, winning several gold, silver, and bronze medals at district, state, and national competitions. These achievements reflect our commitment to nurturing excellence in sports alongside academics.</p>
                            <p>The school provides a safe and encouraging environment where every child is motivated to discover and develop their sporting talents. Through inter-house competitions, annual sports meets, friendly matches, and participation in inter-school tournaments, students learn the values of dedication, perseverance, fair play, and respect for others.</p>
                            <p>At Carmel Convent School, we inspire every student to stay active, dream big, and strive for excellence—both on the field and in life.</p>
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Sports